/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {useEffect, useState} from "react";
import {toast} from "react-hot-toast";
import {usersDataEndpoint} from "../containers/pages/CoverageRequirements/constants";
import {usePostRequest} from "../api/helper";
import {hasThisAccessLevelToRouteKey} from "../redux/ducks/AccessControl/accessControlHelpers";
import {EArgosRouteKeys} from "../Routes/constants";
import {EUserPermissionAccess} from "../redux/ducks/AccessControl/types";

const useFetchUserData = (props: any = undefined) => {
  const [userData, setUserData] = useState<{ [key: string]: { firstName: string, lastName: string, fullName: string } }>({});
  const [isLoading, setIsLoading] = useState(false);
  const fetchHandle = usePostRequest(usersDataEndpoint);

  useEffect(() => {
    if(props?.disabled) return;
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const data = await fetchHandle();
        const filteredUsers = data.filter((userInfo: any) =>
          hasThisAccessLevelToRouteKey(EArgosRouteKeys.COVERAGE_REQUIREMENTS, userInfo, EUserPermissionAccess.READ_WRITE)
        );
        const userMap: { [key: string]: { firstName: string, lastName: string, fullName: string } } = {};
        filteredUsers.forEach((user: any) => {
          userMap[user.id] = {firstName: user.firstName, lastName: user.lastName, fullName: `${user.firstName} ${user.lastName}`};
        });
        setUserData(userMap);
      } catch (error) {
        toast.error("Error querying the database");
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [props?.disabled]);

  return {userData, isLoading};
};

export default useFetchUserData;